import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StockHome from '../features/stock/StockHome';
import StockDetail from '../features/stock/StockDetail';
import AuthRedirect from '../shared/AuthRedirect';
import SubMenu from '../shared/SubMenu';
import { STOCK_MENU_ITEMS } from '../config/menuConfig';

const StockRouter = () => {
  return (
    <>
      <SubMenu items={STOCK_MENU_ITEMS} />
      <Routes>
        <Route path="/" element={<StockHome />} />
        <Route path="/stock/:symbol" element={<StockDetail />} />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default StockRouter;
